/**
 * FeatureName tracks all the features for which we show messages in our product.
 */
export enum FeatureName {
  FEATURE_NAME_UNKNOWN = 'FEATURE_NAME_UNKNOWN',
  FIRST_ORDER_INCENTIVE = 'FIRST_ORDER_INCENTIVE',
  FIRST_ORDER_INCENTIVE_AUTO_EXTEND = 'FIRST_ORDER_INCENTIVE_AUTO_EXTEND',
  FIRST_ORDER_INCENTIVE_LAST_CHANCE = 'FIRST_ORDER_INCENTIVE_LAST_CHANCE',
  BLOCKED_CHECKOUT = 'BLOCKED_CHECKOUT',
  EXPIRED_CARD = 'EXPIRED_CARD',
}
